import {
  IonAlert,
  IonButton,
  IonCol,
  IonIcon,
  IonInput,
  IonItem,
  IonLabel,
  IonModal,
  IonRow,
  IonTextarea,
} from "@ionic/react";
import React, { useEffect, useState } from "react";

import "./CaseHistoryDetailView.scss";

import { utilService } from "../../../services/utilService";
import dayjs from "dayjs";
import MediaListCard from "../../FileShare/components/CaseHistoryMediaListCard/MediaListCard";
import { rolePermissionsService } from "../../../services/rolePermissions.service";
import _ from "lodash";
import { layersOutline, stopCircleOutline, timeOutline } from "ionicons/icons";
import { CONSTANTS } from "../../../constants";
import { AddProviderContext } from "../../StatusBoard/components/StatusBoardTable/components/ExpandedCard/components/SBoardProvider/SBoardProvider";
import SBoardProviderModal from "../../StatusBoard/components/StatusBoardTable/components/ExpandedCard/components/SBoardProvider/SBoardProviderModal/SBoardProviderModal";
import { doctorsListService } from "../../../components/Shared/DoctorList/doctor-list-service";
import { sBoardProviderService } from "../../StatusBoard/components/StatusBoardTable/components/ExpandedCard/components/SBoardProvider/SBoardProvider.service";
import DoctorCard from "../../../components/Shared/DoctorList/Components/DoctorCard/doctor-card";
import { doctorListInputData } from "../../../components/Shared/DoctorList/doctor-list.model";
import { loggedInUserService } from "../../../services/loggedInUser.service";
import EMSNotesContainer from "../EmsNotesContainer/EmsNotesContainer";
import { notesContainerService } from "../EmsNotesContainer/EmsNotesContainer.service";
import { useToast } from "@agney/ir-toast";
import { CaseHistoryService } from "../CaseHistory.service";
import CaseHistoryDetailsEditMedia from "../../../components/Shared/CaseHistoryDetailsEditModal/CaseHistoryDetailsEditModal";
import CaseHistorySiteSelection from "../../../components/Shared/CaseHistorySiteSelection/CaseHistorySiteSelection";
import EMTMediaUpload from "../../FileShare/components/EMTMediaUpload/EMTMediaUpload";
import Call from "../../../components/Shared/Call/call";
import CareTeamAddDeletePopup from "../../../components/Shared/CareTeamAddPopup/CareTeamAddPopup";
import CareTeamCard from "../../../components/Shared/CareTeamCard/CareTeamCard";
import Loader from "../../../components/Shared/Loader/Loader";
import { useTranslation } from "react-i18next";

interface caseHistoryDataListProps {
  listData: any;
  index: any;
  selectedMessageCardDetails: any;
  updateDetailsPage?: any;
  isEditEnabled?: any;
  triggerPatientList: any;
  updateCaseHistoryDetail?: any;
  fetchedcaseHistoryData:any;
}

const CaseHistoryDetailsView: React.FC<caseHistoryDataListProps> = (props) => {
  const { t } = useTranslation("ems");
  const [columnSize, setColumnSize]: any = useState("4");
  const [showProviderCard, setShowProviderCard] = useState(false);
  const [modelType, setModelType]: any = useState();
  const [updateDoctorListResult, setUpdateDoctorListResult]: any = useState();
  const [doctorResult, setDoctorResult]: any = useState([]);
  const [rolePermissions, setRolePermissions] = useState<any>(Object);
  const [doctorListInput, setDoctorListInput]: any = useState({});
  const [isEMTUser, checkEMTUser]: any = useState(false);
  const [transferPatient, setTransferPatient] = useState(false);
  const Toast = useToast();
  const [timerValue, setTimerValue]: any = useState("");
  const [currentTimeValue, setCurrentTimeValue]: any = useState();
  const [startTimer, setStartTimer] = useState(false);
  const [isEdit, setEdit]: any = useState(false);
  const [isEditData, enableEdit] = useState(false);
  const [MRN, setMRN] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [enableSiteSelection, setEnableSiteSelection] = useState(false);
  const [timerSection, setTimerSection] = useState(false);
  const [showSignInAlert, setShowSignInAlert] = useState(false);
  const [userName, setUserName] = useState<string>("");
  const [isShowPassword, setPasswordStatus] = useState(false);
  const [userPassword, setUserPassword] = useState<string>("");
  const [isFormValid, setFormStatus] = useState(false);
  const [isInvalidCredentials, setSignInValidations] = useState(false);
  const [setContactDetails, getContactDetails]: any = useState();
  const [emergencyContactDetails, updateEmergencyContactDetails]: any =
    useState();
  const [showRejectReasonModalAlert, setShowRejectReasonModalAlert] =
    useState(false);
  const [isCancelCase, setIsCancelCase] = useState(false);
  const [isCompleteCase, setIsCompleteCase] = useState(false);
  const [rejectReason, setRejectReason] = useState<string>("");
  const [isInputEmpty, setIsInputEmpty] = useState(true);
  const [showSignInAlertForNote, setShowSignInAlertForNote] = useState(false);
  const [showFullCaseTypeList, setShowFullCaseTypeList] = useState(false);
  const [selectedCaseTypes, setSelectedCaseTypes] = useState([]);
  const [isAttachmentActive, setIsAttachmentActive] = useState(false);
  const [showPopup, setAddDeletePopup] = useState(false);
  const [selectedCareTeam, setSelectedCareTeam] = useState([]);
  const [isLoaderActive, setLoaderStatus] = useState(true);

  useEffect(() => {
    setFormStatus(formValidation());
    setIsInputEmpty(false);
  }, [userName, userPassword]);

  const formValidation = () => {
    return userName && userPassword ? true : false;
  };

  useEffect(() => {
    setDoctorListInputData();
    getSelectedCareTeamList();
    const subscription = loggedInUserService.loggedInUserData.subscribe((data: any) => {
      let isEmtUser = checkIsEMTUser(data?.userData);
      checkEMTUser(isEmtUser);
      if (props.listData.isTransferred) {
        getTimer();
      }
    });
    
    // Module-level Subject: without this, every mount left a live
    // handler behind, so one update was handled once per visit.
    return () => subscription.unsubscribe();
  }, []);

  useEffect(() => {
    if (props.listData.display_name) {
      splitUserDisplayName();
    }
  }, [props.listData.display_name]);

  useEffect(() => {
    if (props.listData.patientCaseTypes) {
      let caseTypeNames = props.listData.patientCaseTypes.map((item: any) => {
        if (item.is_selected === true) {
          return item.case;
        }
      });

      let caseNameLists = caseTypeNames.filter(function (element: any) {
        return element !== undefined;
      });
      setSelectedCaseTypes(caseNameLists);
    }
  }, [props.listData.patientCaseTypes]);

  useEffect(() => {
    if (props.listData.hospital) {
      getEmergencyContactDetails();
    }
  }, [props.listData.hospital]);

  useEffect(() => {
    if (!isEMTUser) {
      if (startTimer) {
        // The interval was never cleared, so every re-run (and unmount) left a
        // 1s timer running forever, stacking duplicates. Capture and clear it.
        const intervalId = setInterval(() => {
          setTimer();
        }, 1000);
        setTimer();
        return () => clearInterval(intervalId);
      }
    }
  }, [startTimer]);

  const checkIsEMTUser = (loggedInUser: any): any => {
    if (loggedInUser) {
      return loggedInUser.roles.some(function (item: any) {
        return item.name === CONSTANTS.ROLES.EMT;
      });
    }
  };

  const splitUserDisplayName = () => {
    const nameArray = props.listData.display_name.split(",");
    setFirstName(nameArray[0]);
    let lastNameValue = nameArray[1] ? nameArray[1] : "";
    setLastName(lastNameValue);
  };

  const getFormattedDateAndTime = (date: any) => {
    const today = dayjs(date).format("MM-DD-YYYY hh:mm A");
    return today;
  };

  const displayProviderCard = (type: String) => {
    setShowProviderCard(true);
    setModelType(type);
  };

  const setDoctorListInputData = () => {
    const doctorListInput: doctorListInputData = {
      componentName: CONSTANTS.COMPONENTS.STATUS_BOARD,
      isMultiSelectEnabled: true,
      isShowColorBadge: false,
      isHideProfilePic: false,
    };
    setDoctorListInput(doctorListInput);
    const rolePermissionData =
      rolePermissionsService.getRolePermissionsDetails();
    setRolePermissions(rolePermissionData);
  };

  const getEmergencyContactDetails = () => {
    const addParams: any = {
      reg_code: utilService.getNetwork(),
      site_network_code: props.listData.hospital.network_code,
      site_id: props.listData.hospital.site_id,
    };
    getEmergencyContact(addParams);
  };

  async function getEmergencyContact(addParams: any) {
    const respTransferPatientResult: any =
      await notesContainerService.getContactDetailsOfEmergency(addParams);
    if (respTransferPatientResult.isSuccess) {
      getContactDetails(respTransferPatientResult.result);
      updateEmergencyContactDetails(
        setDataToCall(respTransferPatientResult.result.result?.[0])
      );
    } else {
      notesContainerService.handleErrorResponse();
    }
  }

  const checkEMS = () => {
    if (isEMTUser) {
      return true;
    } else {
      return false;
    }
  };

  const setUpdatedProviderList = (result: any) => {
    if (result && result.length) {
      setUpdateDoctorListResult(doctorsListService.setDoctorListModel(result));
      sBoardProviderService.setDoctorListDataFromComponent(
        doctorsListService.setDoctorListModel(result)
      );
      setDoctorResult(doctorsListService.setDoctorListModel(result));
    }
    if (
      modelType === CONSTANTS.PROVIDER_POPUPTYPE.PRIMARY_MD &&
      result !== "" &&
      result.length === 0
    ) {
      // props.onCancel(true);
    }
    setShowProviderCard(false);
  };

  const patientTransfer = () => {
    const addParams: any = {
      reg_code: utilService.getNetwork(),
      is_ems: checkEMS(),
      user_guid: utilService.getLoggedUserGuid(),
      is_transferred: true,
      patient_guid: props.listData.patient_guid,
      site_guid: props.listData.site_guid,
      ems_network_code: props.listData.emsNetworkCode,
    };
    transferPatientData(addParams);
  };

  async function getTimer() {
    const params: any = {
      patient_guid: props.listData.patient_guid,
    };
    const respTimerResult: any = await CaseHistoryService.getTimer(params);
    if (respTimerResult.isSuccess) {
      setCurrentTimeValue(respTimerResult.displayNotesCard.result?.[0]);
      setStartTimer(true);
    } else {
      notesContainerService.handleErrorResponse();
    }
  }

  let startTime: any = new Date();

  const setTimer = () => {
    let updatedTime = new Date(
      currentTimeValue.year,
      currentTimeValue.monthIndex,
      currentTimeValue.day,
      currentTimeValue.hours,
      currentTimeValue.minutes,
      currentTimeValue.seconds
    );
    let diff = new Date().valueOf() - startTime.valueOf();
    updatedTime.setMilliseconds(updatedTime.getMilliseconds() + diff);
    var seconds = updatedTime.getSeconds();
    var minutes = updatedTime.getMinutes();
    var hours = updatedTime.getHours();
    var day = setDayValue(currentTimeValue.day);
    var currentTime = day + hours + ":" + minutes + ":" + seconds;
    setTimerValue(currentTime);
  };

  const setDayValue = (dayValue: any) => {
    let day = dayValue === (0 || null) ? " 0 - " : dayValue + " - ";
    return day;
  };

  const handleTimer = () => {
    const addParams: any = {
      reg_code: utilService.getNetwork(),
      is_stopped: true,
      user_guid: utilService.getLoggedUserGuid(),
      patient_guid: props.listData.patient_guid,
      action_username: userName,
      action_password: userPassword,
    };
    setSignInValidations(false);
    setUserName("");
    setUserPassword("");
    stopTimer(addParams);
  };

  async function stopTimer(addParams: any) {
  
    const respTimer: any = await notesContainerService.stopTimer(addParams);
    if (respTimer.isSuccess) {
      Toast.success(t("timerStopped"));
      props.updateDetailsPage(props.listData.id,props?.listData?.inpatient);
      props?.triggerPatientList();
      setShowSignInAlert(false);
    } else {
      notesContainerService.handleErrorResponse();
      setSignInValidations(true);
    }
  }

  const terminateCase = () => {
    const addParams: any = {
      reg_code: utilService.getNetwork(),
      is_ems: checkEMS(),
      user_guid: utilService.getLoggedUserGuid(),
      action_type: isCancelCase ? "cancel" : "complete",
      notes: rejectReason,
      patient_guid: props.listData.patient_guid,
      site_guid: props.listData.site_guid,
      ems_network_code: props.listData.emsNetworkCode,
      action_username: userName,
      action_password: userPassword,
    };
    terminateCaseDetails(addParams);
  };

  
  async function terminateCaseDetails(addParams: any) {
    const respData: any = await CaseHistoryService.updateTerminateCase(
      addParams
    );
    if (respData.isSuccess) {
      Toast.success(t("caseDetailsUpdated"));
      setShowSignInAlertForNote(false);
      props.updateCaseHistoryDetail(props?.listData?.id,props?.listData?.inpatient);
    } else {
      setSignInValidations(true);
    }
  }

  async function transferPatientData(addParams: any) {
    const respTransferPatientResult: any =
      await notesContainerService.transferPatient(addParams);
    if (respTransferPatientResult.isSuccess) {
      Toast.success(t(isEMTUser ? "transferCompleted" : "admitted"));
      props.updateDetailsPage(props.listData.id,props?.listData?.inpatient);
    } else {
      notesContainerService.handleErrorResponse();
    }
  }

  async function getSelectedCareTeamList() {
    setLoaderStatus(true);
    let params = {
      reg_code: utilService.getNetwork(),
      patient_id: props.listData.id,
    };
    const respTransferPatientResult: any =
      await CaseHistoryService.getCareTeamList(params);
    if (respTransferPatientResult.isSuccess) {
      setSelectedCareTeam(respTransferPatientResult.groupList);
      setLoaderStatus(false);
    } else {
      notesContainerService.handleErrorResponse();
      setLoaderStatus(false);
    }
    setLoaderStatus(false);
  }

  const updateDetailsPage = (ProviderUpdated: any) => {
    if (ProviderUpdated) {
      props.updateDetailsPage(ProviderUpdated,props?.listData?.inpatient);
      setShowProviderCard(false);
      setEdit(false);
    }
  };

  const updateCaseDetailsPage = (ProviderUpdated: any) => {
    if (ProviderUpdated) {
      props.updateDetailsPage(ProviderUpdated,props?.listData?.inpatient);
      props.updateDetailsPage(props.listData.id,props?.listData?.inpatient);
    }
  };

  const updatePage = () => {
    return true;
  };

  const updateMRN = () => {
    const addParams: any = {
      reg_code: utilService.getNetwork(),
      mr_number: MRN,
      user_guid: utilService.getLoggedUserGuid(),
      patient_guid: props.listData.patient_guid,
    };
    addMRN(addParams);
    setEdit(false);
  };

  async function addMRN(addParams: any) {
    const respTransferPatientResult: any = await notesContainerService.addMRN(
      addParams
    );
    if (respTransferPatientResult.isSuccess) {
      Toast.success(CONSTANTS.MESSAGES.MRN);
      props.updateDetailsPage(props.listData.id,props?.listData?.inpatient);
    } else {
      notesContainerService.handleErrorResponse();
    }
  }

  const onShowPassword = () => {
    setPasswordStatus(!isShowPassword);
  };

  const setDataToCall = (contact: any) => {
    return {
      callTo: "sites",
      contactNumber: contact ? contact.contactDetails.number : "",
      name: props.listData.hospital.site,
    };
  };

  const setTransferLabel = () => {
    return t(isEMTUser ? "transfer" : "admit");
  };

  const setConfirmationLabel = () => {
    return t(isEMTUser ? "transfer" : "admit");
  };

  const checkIfInputEmpty = () => {
    const isWhitespace = utilService.checkIfInputEmpty("groupSmsText");
    setIsInputEmpty(isWhitespace);
  };

  const setReasonLabel = () => {
    if (isCancelCase) {
      return t("reasonToCancelCase");
    } else if (isCompleteCase) {
      return t("reasonToCompleteCase");
    }
  };

  const checkCaseDetails = () => {
    if (props.listData.isCancelled) {
      return true;
    } else if (props.listData.isCompleted) {
      return true;
    } else {
      return false;
    }
  };

  const updateCancelCompleteLabel = () => {
    if (props.listData.isCancelled) {
      return t("caseCancelled");
    } else if (props.listData.isCompleted) {
      return t("caseCompletion");
    }
  };

  const getAttachmentActive = (status: any) => {
    setIsAttachmentActive(status);
  };

  const refreshData = (data: any) => {
    setAddDeletePopup(false);
    // props.updateDetailsPage(props.listData.id);
    getSelectedCareTeamList();
  };

  const showAddDeletePopup = () => {
    setAddDeletePopup(true);
  };

  const getCaseStatus = () => {
    if (props.listData.isCancelled) {
      return true;
    } else if (props.listData.isCompleted) {
      return true;
    }
    return false;
  };

  const checkInputValue = () => {
    const isWhitespace: boolean = utilService.checkIfInputEmpty("groupSmsText");
    return isWhitespace;
  };

  const setDisplayName = (name: any) => {
    let patientName;
    if (name[0] === ",") {
      patientName = name.replaceAll(",", "");
    } else {
      patientName = name;
    }
    return patientName;
  };

  return (
    <div
      className={`${
        props.listData.isCompleted || props.listData.isCancelled
          ? ""
          : "case-history-main-details"
      }`}
    >
      {isEditData && (
        <CaseHistoryDetailsEditMedia
          showPatientAlert={isEditData}
          showAlert={() => {
            enableEdit(false);
            setEdit(false);
          }}
          caseDetails={props.listData}
          updateCaseDetailsPage={updateCaseDetailsPage}
          listData={props.listData}
          fetchedcaseHistoryData={props.fetchedcaseHistoryData}
        ></CaseHistoryDetailsEditMedia>
      )}

      {enableSiteSelection && (
        <CaseHistorySiteSelection
          showPatientAlert={enableSiteSelection}
          showAlert={() => {
            setEnableSiteSelection(false);
          }}
          caseDetails={props.listData}
          updateCaseDetailsPage={updateCaseDetailsPage}
          isRejected={props.listData.isRejected}
        ></CaseHistorySiteSelection>
      )}

      <IonAlert
        isOpen={transferPatient}
        onDidDismiss={() => {
          setTransferPatient(false);
        }}
        cssClass="fav-delete-alert"
     header={t("confirmationMessage")}
message={t("confirmPatientAction", { action: setConfirmationLabel() })}
        buttons={[
          {
            text: t("no"),
            role: "cancel",
            cssClass: "secondary",
          },
          {
            text: t("ok"),
            handler: () => {
              patientTransfer();
              setTransferPatient(false);
            },
          },
        ]}
      />
      <IonAlert
        isOpen={timerSection}
        onDidDismiss={() => {
          setTimerSection(false);
        }}
        cssClass="fav-delete-alert"
     header={t("confirmationMessage")}
     message={t("stopTimerConfirm")}
        buttons={[
          {
            text: t("no"),
            role: "cancel",
            cssClass: "secondary",
          },
          {
            text: t("ok"),
            handler: () => {
              setShowSignInAlert(true);
              setTimerSection(false);
            },
          },
        ]}
      />

      <IonModal
        isOpen={showSignInAlert}
        backdropDismiss={false}
        className="add-fav-modal sign-In-modal"
      >
        <div className="label-div">
          <div className="label-name">{t("signIn")}</div>
          <div
            className="input-icon icon-close"
            onClick={() => {
              setShowSignInAlert(false);
              setUserName("");
              setUserPassword("");
              setSignInValidations(false);
            }}
          ></div>
        </div>
        <form className="sign-in-input-container" autoComplete="off">
          <div className="signin-input-wrapper">
            <IonItem className="item-input">
              <IonLabel className="item-label" position="floating">
                Username
              </IonLabel>
              <IonInput
                className="ion-input"
                name="username"
                type="search"
                value={userName}
                onIonChange={(event) => {
                  setUserName(event.detail.value!);
                  setSignInValidations(false);
                }}
                autocomplete="off"
                maxlength={25}
              >
                {" "}
              </IonInput>
            </IonItem>
          </div>
          <div className="signin-input-wrapper">
            <div
              className={`input-icon clickable ${
                isShowPassword ? "icon-show_password" : "icon-hide_password"
              }`}
              onClick={onShowPassword}
            ></div>
            <IonItem className="item-input">
              <IonLabel className="item-label" position="floating">
                Password
              </IonLabel>
              <IonInput
                className="ion-input"
                type={isShowPassword ? "text" : "password"}
                name="password"
                value={userPassword}
                onIonChange={(event) => {
                  setUserPassword(event.detail.value!);
                }}
                autocomplete="new-password"
              >
                {" "}
              </IonInput>
            </IonItem>
          </div>
          <div className="signin-validations" hidden={!isInvalidCredentials}>
            {t("invalidCredentials")}
          </div>
        </form>

        <div className="add-fav-button-container">
          <div className="cancel-button-div sign-in-btn">
            <IonButton
              color="medium"
              className="button secondary-btn  btn-curved"
              onClick={() => {
                setUserName("");
                setUserPassword("");
              }}
            >
              {t("clear")}
            </IonButton>
          </div>
          <div className="send-button-div sign-in-btn">
            <IonButton
              disabled={!isFormValid}
              className="submit-btn button primary-btn btn-curved"
              onClick={() => {
                handleTimer();
              }}
            >
              {t("signIn")}
            </IonButton>
          </div>
        </div>
      </IonModal>
      <div className="btn-wrapper menu-list-top">
        <>
          {!isEMTUser && (
            <>
              {" "}
              <IonButton
                className={`complete-case-btn button secondary-transparent-btn button-xsm btn-curved  ${
                  isEMTUser ? "emt-case-details" : ""
                }`}
                onClick={() => {
                  setShowRejectReasonModalAlert(true);
                  setIsCancelCase(false);
                  setIsCompleteCase(true);
                  setRejectReason("");
                }}
                hidden={checkCaseDetails()}
              >
{t("complete")}              </IonButton>
              <IonButton
                className={`cancel-case-btn button secondary-transparent-btn button-xsm btn-curved  ${
                  isEMTUser ? "emt-case-details" : ""
                }`}
                onClick={() => {
                  setShowRejectReasonModalAlert(true);
                  setIsCancelCase(true);
                  setIsCompleteCase(false);
                  setRejectReason("");
                  // props.updateDetailsPage(props.listData.id);
                }}
                hidden={checkCaseDetails()}
              >
                {t("cancel")}
              </IonButton>
              <IonButton
                className={`refresh-btn button secondary-transparent-btn button-xsm btn-curved  ${
                  isEMTUser ? "emt-case-details" : ""
                }`}
                onClick={() => {
                  props.updateDetailsPage(props.listData.id,props?.listData?.inpatient);
                }}
                hidden={checkCaseDetails()}
              >
                {t("refresh")}
              </IonButton>
            </>
          )}
          {props.listData.canEdit && (
            <IonButton
              className={`button secondary-transparent-btn button-xsm btn-curved case-details-edit ${
                isEMTUser ? "emt-case-details" : ""
              }`}
              onClick={() => {
                enableEdit(true);
              }}
              hidden={checkCaseDetails()}
            >
              {t("edit")}
            </IonButton>
          )}
        </>
      </div>

      <IonModal
        isOpen={showRejectReasonModalAlert}
        backdropDismiss={false}
        // cssClass="add-fav-modal reject-patient-modal"
        className="complete-case-modal"
      >
        <div className="label-div">
          <div className="label-name">{setReasonLabel()}</div>
          <div
            className="input-icon icon-close"
            onClick={() => {
              setShowRejectReasonModalAlert(false);
              setRejectReason("");
            }}
          ></div>
        </div>
        <div className="comment-box-section">
          <IonTextarea
            className="textarea-div"
            maxlength={250}
            value={rejectReason}
            placeholder={setReasonLabel()}
            id="groupSmsText"
            onIonChange={(e) => {
              checkIfInputEmpty();
              setRejectReason(e.detail.value!);
            }}
          ></IonTextarea>
        </div>

        <div className="add-fav-button-container">
          <div className="cancel-button-div">
            <IonButton
              color="medium"
              className="button secondary-btn  btn-curved"
              onClick={() => {
                // setShowModalAlert(false);
                setRejectReason("");
              }}
            >
              Clear
            </IonButton>
          </div>
          <div className="send-button-div">
            <IonButton
              disabled={checkInputValue()}
              className="submit-btn case-complete-button button primary-btn btn-curved"
              onClick={() => {
                setShowRejectReasonModalAlert(false);
                setShowSignInAlertForNote(true);
              }}
            >
              {t("update")}
            </IonButton>
          </div>
        </div>
      </IonModal>

      <IonModal
        isOpen={showSignInAlertForNote}
        backdropDismiss={false}
        className="add-fav-modal sign-In-modal"
      >
        <div className="label-div">
          <div className="label-name">{t("signIn")}</div>
          <div
            className="input-icon icon-close"
            onClick={() => {
              setShowSignInAlertForNote(false);
              setUserName("");
              setUserPassword("");
              setSignInValidations(false);
            }}
          ></div>
        </div>
        <form className="sign-in-input-container" autoComplete="off">
          <div className="signin-input-wrapper">
            <IonItem className="item-input">
              <IonLabel className="item-label" position="floating">
                {t("username")}
              </IonLabel>
              <IonInput
                className="ion-input"
                name="username"
                type="search"
                value={userName}
                onIonChange={(event) => {
                  setUserName(event.detail.value!);
                  setSignInValidations(false);
                }}
                autocomplete="off"
                maxlength={25}
              >
                {" "}
              </IonInput>
            </IonItem>
          </div>
          <div className="signin-input-wrapper">
            <div
              className={`input-icon clickable ${
                isShowPassword ? "icon-show_password" : "icon-hide_password"
              }`}
              onClick={onShowPassword}
            ></div>
            <IonItem className="item-input">
              <IonLabel className="item-label" position="floating">
                {t("password")}
              </IonLabel>
              <IonInput
                className="ion-input"
                type={isShowPassword ? "text" : "password"}
                name="password"
                value={userPassword}
                onIonChange={(event) => {
                  setUserPassword(event.detail.value!);
                  setSignInValidations(false);
                }}
                autocomplete="new-password"
              >
                {" "}
              </IonInput>
            </IonItem>
          </div>
          <div className="signin-validations" hidden={!isInvalidCredentials}>
           {t("invalidCredentials")}
          </div>
        </form>

        <div className="add-fav-button-container">
          <div className="cancel-button-div sign-in-btn">
            <IonButton
              color="medium"
              className="button secondary-btn  btn-curved"
              onClick={() => {
                setUserName("");
                setUserPassword("");
              }}
            >
              {t("clear")}
            </IonButton>
          </div>
          <div className="send-button-div sign-in-btn">
            <IonButton
              disabled={!isFormValid}
              className="submit-btn button primary-btn btn-curved"
              onClick={() => {
                terminateCase();
              }}
            >
              {t("signIn")}
            </IonButton>
          </div>
        </div>
      </IonModal>

      {showPopup && (
        <CareTeamAddDeletePopup
          careTeamList={selectedCareTeam}
          showModal={showPopup}
          popUpType={CONSTANTS.STATUS_BOARD_ROWTYPE.CARE_TEAM}
          patientID={props.listData.id}
          siteId={props.listData.hospital.site_id}
          onCancel={refreshData}
        ></CareTeamAddDeletePopup>
      )}

      <IonModal
        isOpen={showFullCaseTypeList}
        backdropDismiss={false}
        className="case-type-modal"
      >
        <div className="label-div">
          <div className="label-name">{t("caseTypes")}</div>
          <div
            className="input-icon icon-close"
            onClick={() => {
              setShowFullCaseTypeList(false);
            }}
          ></div>
        </div>
        <form action="">
          <ul className="case-type-list-view">
            {selectedCaseTypes.map((item: any) => {
              return <li>{item}</li>;
            })}
          </ul>
        </form>
      </IonModal>

      <div
        className={`container case-details-header border-bottom mt-1 pt-md-3 ${
          isEMTUser ? "adjust-case-details-header" : ""
        }`}
      >
        <div className="row">
          <div className="col-md-5">
            {props.listData.inpatient && (
              <div className="in-patient">{t("inpatient")}</div>
            )}
            {props.listData.isCompleted && (
              <div className="completed-case">{t("completed")}</div>
            )}
            {props.listData.isCancelled && (
              <div className="cancelled-case">{t("cancelled")}</div>
            )}
            <div className="p-md-2 patient-name-container">
              <h5 className="patient-details">
                {" "}
                {setDisplayName(props.listData.name)}
              </h5>
              <div className="text-muted">
                {props.listData.gender && (
                  <>
                    <span className="highlight-info">
                      {props.listData.gender}
                      {props.listData.age && (
                        <span> | {props.listData.age} </span>
                      )}
                      {!props.listData.age && (
                        <span> | {props.listData.dob} </span>
                      )}
                    </span>
                    <br />
                  </>
                )}

                {props.listData.isTransferred &&
                  !props.listData.inpatient &&
                  !isEMTUser && (
                    <span className="mrn_container">
                      {props.listData.mrn && (
                        <span className="patient-details">
                          {t("mrn")} :{" "}
                          <span className="warning-message">
                            {props.listData.mrn}
                          </span>
                        </span>
                      )}
                    </span>
                  )}

                {props.listData.inpatient && !isEMTUser && (
                  <span className="mrn_container">
                    {props.listData.mrn && (
                      <span className="patient-details">
                        {t("mrn")} :{" "}
                        <span className="warning-message">
                          {props.listData.mrn}
                        </span>
                      </span>
                    )}
                  </span>
                )}
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="p-md-1 text-muted case-type-name-main">
              {selectedCaseTypes.length !== 0 && (
                <span className="highlight-info case-type-name">
                  {selectedCaseTypes[0]}
                </span>
              )}

              {selectedCaseTypes.length >= 2 && (
                <div
                  className="multi-case-type-container"
                  onClick={() => {
                    setShowFullCaseTypeList(true);
                  }}
                >
                  <IonIcon
                    className="multi-case-type"
                    icon={layersOutline}
                  ></IonIcon>
                </div>
              )}
            </div>
          </div>
          <div className="col-md-4 timer-container-section">
            {props.listData.isTransferred && !props.listData.timerStopped && (
              <>
                <div className="p-md-1 text-muted timer-section">
                  {timerValue && (
                    <>
                      <span className="highlight-info timer-details">
                        {timerValue}
                      </span>
                      <span className="highlight-timer-info">
                        <span className="timer-label">
                          {" "}
                          {props.listData.inpatient
                            ? `${t("startTime")} :`
                            : `${t("sinceTransfer")} :`}{" "}
                        </span>
                        {getFormattedDateAndTime(
                          props.listData.timerStart_time
                        )}
                      </span>
                    </>
                  )}
                  {timerValue && (
                    <div
                      className="timer-stop-menu"
                      onClick={() => {
                        setTimerSection(true);
                      }}
                    >
                      <IonIcon
                        className="timer-stop"
                        icon={stopCircleOutline}
                      ></IonIcon>
                    </div>
                  )}
                </div>
              </>
            )}
            {props.listData.timerStopped && (
              <div
                className={`total-duration ${
                  props.listData.isCancelled
                    ? "align-total-duration-button"
                    : ""
                }
              ${props.listData.isCompleted ? "align-total-duration-button" : ""}
              `}
                title="Duration"
              >
                <IonIcon
                  class="timer-icon-case-details"
                  title="Duration"
                  icon={timeOutline}
                ></IonIcon>
                {props.listData.timerDuration}
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="tab-content w-100 pt-md-0">
        <div
          className="tab-pane show active"
          id="user"
          role="tabpanel"
          aria-labelledby="user-tab"
        >
          <div
            className={`container case-history-small-screen rounded-bottom 
                       ${isEMTUser ? "ems-case-details-page" : ""}`}
          >
            <div className="row pl-lg-2 pt-md-0 pt-sm-2">
              <div className="col-md-6 py-md-4 site-title">
                {props.listData.canTransfer && (
                  <span
                    className="highlight-info transfer-patient"
                    onClick={() => {
                      setTransferPatient(true);
                      getTimer();
                    }}
                  >
                    {setTransferLabel()}
                  </span>
                )}

                {props.listData.isRejected && isEMTUser && (
                  <span className="highlight-info rejected-patient">
                    Rejected
                  </span>
                )}
                {props.listData.isTransferred && isEMTUser && (
                  <span className="highlight-info transferred-patient">
                    Transferred
                  </span>
                )}

                {props.listData.isCancelled && isEMTUser && (
                  <span className="highlight-info cancelled-completed-patient"></span>
                )}

                {props.listData.isCompleted && isEMTUser && (
                  <span className="highlight-info cancelled-completed-patient"></span>
                )}

                {props.listData.caseSubmitted && isEMTUser && (
                  <span className="highlight-info case-submitted">
                    Case Submitted
                  </span>
                )}
                {props.listData.isRejected && isEMTUser && (
                  <span
                    className="highlight-info ems-site-edit"
                    onClick={() => {
                      setEnableSiteSelection(true);
                    }}
                  >
                    Resend Request
                  </span>
                )}

                {props.listData.caseSubmitted && isEMTUser && (
                  <span
                    className="highlight-info ems-site-edit"
                    onClick={() => {
                      setEnableSiteSelection(true);
                    }}
                  >
                    Resend Request
                  </span>
                )}
                {!props.listData.isRejected && (
                  <>
                    <h6 className="patient-details hospital-details">
                      {t("hospital")}  :
                      {isEMTUser && (
                        <div className="ems-call-button">
                          <Call
                            selectedDoctorGuid=""
                            dataFromParent={emergencyContactDetails}
                            isAssignedNumber={true}
                          ></Call>
                        </div>
                      )}
                    </h6>
                    <p className="site-name warning-message">
                      {props.listData.hospital.site}
                    </p>
                  </>
                )}

                {(props.listData.isCompleted || props.listData.isCancelled) && (
                  <>
                    <h6 className="patient-details">
                      {updateCancelCompleteLabel()} note:
                    </h6>
                    <span className="site-name warning-message completed-note">
                      {props.listData.cancelCompleteInfo.note}
                    </span>
                    <h6 className="patient-details completed-section-date">
                      {" "}
                      {updateCancelCompleteLabel()} date :{" "}
                      <span className="case-completed-date">
                        {props.listData.cancelCompleteInfo.date}
                      </span>
                    </h6>
                    <h6 className="patient-details completed-section-date">
                      {" "}
                      {updateCancelCompleteLabel()} by :{" "}
                      <span className="case-completed-date">
                        {props.listData.cancelCompleteInfo.done_by}
                      </span>
                    </h6>
                  </>
                )}

                {!props.listData.inpatient && (
                  <>
                    <div hidden={checkCaseDetails()}>
                      <h6 className="patient-details">{t("messageFromEmt")} :</h6>
                      <span className="site-name warning-message">
                        {props.listData.message}
                      </span>
                    </div>
                  </>
                )}

                {props.listData.inpatient && (
                  <>
                    <h6 className="patient-details">{t("statusBoardDetails")}</h6>
                    <span className="site-name warning-message">
                      Statusboard : {props.listData.statusBoardName}
                    </span>{" "}
                    <br />
                    <span className="site-name warning-message">
                      Unit : {props.listData.unitName}
                    </span>{" "}
                    <br />
                    <span className="site-name warning-message">
                      Bed : {props.listData.bedNumber}
                    </span>{" "}
                    <br />
                  </>
                )}

                <div
                  className="media-btn-container"
                  hidden={checkCaseDetails()}
                >
                  <EMTMediaUpload
                    doctorListDataFromParent={""}
                    isFromPatientForm={true}
                    smsThread={"smsThreadID"}
                    onOk={() => {}}
                    onCancel={() => {}}
                    selectedUsers={""}
                    isFromCaseDetailsEdit={true}
                    patientDataID={props.listData.id}
                    siteGUID={props.listData.site_guid}
                    updateDetailsPage={updateDetailsPage}
                    attachmentActive={getAttachmentActive}
                    isTransferred={props.listData.isTransferred}
                    isEMTUser={isEMTUser}
                  ></EMTMediaUpload>
                </div>
                <div className="case-history-message-details">
                  {props.listData.media_file && (
                    <>
                      <h6 className="patient-details">{t("ekg")} :</h6>
                      <IonRow className="media-list-height">
                        {!_.isEmpty(props.listData.media_file.ekg) ? (
                          props.listData.media_file.ekg.map((item: any) => {
                            return (
                              <IonCol size-lg={columnSize} size="6">
                                <MediaListCard
                                  selectedPatientId={
                                    props.listData.selectedPatientId
                                  }
                                  selectedUserId={
                                    props.listData.selectedUserGuid
                                  }
                                  mediaItem={item}
                                  selectedDoctorData={
                                    props.listData.selectedDoctorDetails
                                  }
                                  fromMessageListCard={true}
                                  smsThreadId={props.listData.smsThreadId}
                                ></MediaListCard>
                              </IonCol>
                            );
                          })
                        ) : (
                          <div>
                            <div className="warning-message">
  {t("noEkgFilesAvailable")}
                            </div>
                          </div>
                        )}
                      </IonRow>

                      <h6 className="patient-details">{t("images")}:</h6>
                      <IonRow className="media-list-height">
                        {!_.isEmpty(props.listData.media_file.image) ? (
                          props.listData.media_file.image.map((item: any) => {
                            return (
                              <IonCol size-lg={columnSize} size="6">
                                <MediaListCard
                                  selectedPatientId={
                                    props.listData.selectedPatientId
                                  }
                                  selectedUserId={
                                    props.listData.selectedUserGuid
                                  }
                                  mediaItem={item}
                                  selectedDoctorData={
                                    props.listData.selectedDoctorDetails
                                  }
                                  fromMessageListCard={true}
                                  smsThreadId={props.listData.smsThreadId}
                                ></MediaListCard>
                              </IonCol>
                            );
                          })
                        ) : (
                          <div>
                            <div className="warning-message">
                              {t("noImageFilesAvailable")}
                            </div>
                          </div>
                        )}
                      </IonRow>
                      <h6 className="patient-details">{t("audio")} :</h6>
                      <IonRow className="media-list-height">
                        {!_.isEmpty(props.listData.media_file.audio) ? (
                          props.listData.media_file.audio.map((item: any) => {
                            return (
                              <IonCol size-lg={columnSize} size="6">
                                <MediaListCard
                                  selectedPatientId={
                                    props.listData.selectedPatientId
                                  }
                                  selectedUserId={
                                    props.listData.selectedUserGuid
                                  }
                                  mediaItem={item}
                                  selectedDoctorData={
                                    props.listData.selectedDoctorDetails
                                  }
                                  fromMessageListCard={true}
                                  smsThreadId={props.listData.smsThreadId}
                                ></MediaListCard>
                              </IonCol>
                            );
                          })
                        ) : (
                          <div>
                            <div className="warning-message">
                              {t("noAudioFilesAvailable")}
                            </div>
                          </div>
                        )}
                      </IonRow>
                      <h6 className="patient-details">{t("videos")} :</h6>
                      <IonRow className="media-list-height">
                        {!_.isEmpty(props.listData.media_file.video) ? (
                          props.listData.media_file.video.map((item: any) => {
                            return (
                              <IonCol size-lg={columnSize} size="6">
                                <MediaListCard
                                  selectedPatientId={
                                    props.listData.selectedPatientId
                                  }
                                  selectedUserId={
                                    props.listData.selectedUserGuid
                                  }
                                  mediaItem={item}
                                  selectedDoctorData={
                                    props.listData.selectedDoctorDetails
                                  }
                                  fromMessageListCard={true}
                                  smsThreadId={props.listData.smsThreadId}
                                ></MediaListCard>
                              </IonCol>
                            );
                          })
                        ) : (
                          <div>
                            <div className="warning-message">
                              {t("noVideoFilesAvailable")}
                            </div>
                          </div>
                        )}
                      </IonRow>
                    </>
                  )}
                </div>
              </div>

              <div className="col-md-6 py-md-4 site-title">
                <div hidden={!props.listData.inpatient}>
                  <span className="add-pmd-label patient-details">
                    {t("emergencyInitiatedBy")}
                  </span>
                  <IonRow>
                    {props?.listData && !_.isEmpty(props.listData) ? (
                      props?.listData?.addedToEmergencyUser?.map(
                        (item: any, index: any) => {
                          return (
                            <IonCol size-lg="12" size="12" key={item.guid}>
                              <DoctorCard
                                key={item.guid}
                                numberBadge={item.numberBadge}
                                doctorData={item}
                                getSelectedCards={() => {}}
                                doctorListInputDetails={doctorListInput}
                                rolePermissions={rolePermissions}
                                emsAddProvider={true}
                                patientDataID={props.listData.id}
                                patientID={props.listData.id}
                                updateCaseDetailsPage={updateCaseDetailsPage}
                                updateTeamList={updatePage}
                              ></DoctorCard>
                            </IonCol>
                          );
                        }
                      )
                    ) : (
                      <div className="no-results-label">
                        {t("noOnCallProviders")}
                      </div>
                    )}
                  </IonRow>
                </div>
                <div hidden={props.listData.inpatient}>
                  <span hidden={isEMTUser} className="primary-md-list-view">
                    {t("emergencyAcceptedBy")}
                  </span>
                  <IonRow>
                    {props?.listData && !_.isEmpty(props.listData) ? (
                      props?.listData?.addedToEmergencyUser?.map(
                        (item: any, index: any) => {
                          return (
                            <IonCol key={item.guid}>
                              <DoctorCard
                                key={item.guid}
                                numberBadge={item.numberBadge}
                                doctorData={item}
                                getSelectedCards={() => {}}
                                doctorListInputDetails={doctorListInput}
                                rolePermissions={rolePermissions}
                                emsAddProvider={true}
                                patientDataID={props.listData.id}
                                patientID={props.listData.id}
                                updateCaseDetailsPage={updateCaseDetailsPage}
                                updateTeamList={updatePage}
                              ></DoctorCard>
                            </IonCol>
                          );
                        }
                      )
                    ) : (
                      <div className="no-results-label">
                        {t("noOnCallProviders")}
                      </div>
                    )}
                  </IonRow>
                </div>
                <div
                  className={`notes-wrapper-col ${
                    props.listData.isCompleted || props.listData.isCancelled
                      ? "hide-message-section"
                      : ""
                  }`}
                  hidden={props.listData.inpatient}
                >
                  <EMSNotesContainer
                    isFromCaseDetails={true}
                    patientGuid={props.listData.patient_guid}
                    siteGuid={props.listData.site_guid}
                    isEMT={isEMTUser}
                    emsNetworkCode={props.listData.emsNetworkCode}
                    adjustMessageSection={props.listData.isCompleted}
                  />
                </div>

                {!isEMTUser && (
                  <div>
                    <AddProviderContext.Provider
                      value={{
                        updateProviderList: (result: any) =>
                          setUpdatedProviderList(result),
                        fromComponent: CONSTANTS.COMPONENTS.STATUS_BOARD,
                        popUptype: modelType,
                        SelectedSupportStaffDetails: {
                          common_provider: {},
                          guid: "",
                          id: null,
                          name: "",
                          site: null,
                          specialisation: null,
                        },
                      }}
                    >
                      <SBoardProviderModal
                        showModal={showProviderCard}
                        onCancel={() => {
                          setShowProviderCard(false);
                        }}
                        siteId={props.listData.hospital.site_id}
                        pId={props.listData.id}
                        isFromCaseHistory={true}
                        updateDetailsPage={updateDetailsPage}
                        providerList={props?.listData?.providers}
                      />
                    </AddProviderContext.Provider>

                    <div className="ems-primary-md-button">
                      <div
                        className={`${
                          props.listData.isCompleted ||
                          props.listData.isCancelled
                            ? "case-completed"
                            : ""
                        }`}
                        onClick={() =>
                          displayProviderCard(
                            CONSTANTS.PROVIDER_POPUPTYPE.PROVIDER
                          )
                        }
                        //
                      >
                        <span className="add-pmd-icon">
                          {/* <IonIcon slot="start" icon={addOutline} /> */}
                          <span className="icon-add"></span>
                        </span>
                        <span className="add-pmd-label patient-details">
                          {t("providers")}
                        </span>
                      </div>
                    </div>
                    <div className="primary-md-list-view">
                      <IonRow>
                        {props.listData.providers &&
                        !_.isEmpty(props.listData.providers)
                          ? props.listData.providers.map(
                              (item: any, index: any) => {
                                return (
                                  <IonCol
                                    size-lg="12"
                                    size="12"
                                    key={item.guid}
                                  >
                                    <DoctorCard
                                      key={item.guid}
                                      numberBadge={item.numberBadge}
                                      doctorData={item}
                                      getSelectedCards={() => {}}
                                      doctorListInputDetails={doctorListInput}
                                      rolePermissions={rolePermissions}
                                      patientDataID={props.listData.id}
                                      patientID={props.listData.id}
                                      updateTeamList={updatePage}
                                      updateCaseDetailsPage={
                                        updateCaseDetailsPage
                                      }
                                      caseDetailsPageProviderList={true}
                                      isCancelledOrCancelled={getCaseStatus()}
                                    ></DoctorCard>
                                  </IonCol>
                                );
                              }
                            )
                          : [
                              !isLoaderActive && (
                                <div className="no-result-care-team" key={""}>
                                  {t("noProvidersAssigned")}
                                </div>
                              ),
                            ]}
                      </IonRow>
                    </div>
                  </div>
                )}
                {!isEMTUser && (
                  <>
                    <div>
                      <div className="ems-primary-md-button">
                        <div
                          className={`${
                            props.listData.isCompleted ||
                            props.listData.isCancelled
                              ? "case-completed"
                              : ""
                          }`}
                          onClick={showAddDeletePopup}
                          //
                        >
                          <span className="add-pmd-icon">
                            <span className="icon-add"></span>
                          </span>
                          <span className="add-pmd-label patient-details">
                            {t("addCareTeam")}
                          </span>
                        </div>
                      </div>
                      <div className="care-team-list-view">
                        {isLoaderActive && (
                          <div className="loader-container">
                            <Loader></Loader>
                          </div>
                        )}
                        <IonRow>
                          {selectedCareTeam && !_.isEmpty(selectedCareTeam)
                            ? selectedCareTeam.map((item: any, index: any) => {
                                return (
                                  <IonCol
                                    size-lg="12"
                                    size="12"
                                    key={item.guid}
                                  >
                                    <CareTeamCard
                                      key={item.id}
                                      careTeamData={item}
                                      patientID={props.listData.id}
                                    ></CareTeamCard>
                                  </IonCol>
                                );
                              })
                            : [
                                !isLoaderActive && (
                                  <div className="no-result-care-team" key={""}>
                                    {t("noCareTeamsAssigned")}
                                  </div>
                                ),
                              ]}
                        </IonRow>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CaseHistoryDetailsView;
